import { useCallback, useEffect, useRef, useState } from "react";
import { supabase } from "../supabaseClient";
import { processFinalization } from "../utility/processTournamentData/processFinalization/processFinalization";

export function useTournamentFinalizationStatus(
  tournamentId,
  refreshTrigger = 0
) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const hasLoaded = useRef(false);

  const load = useCallback(async () => {
    if (!tournamentId) return;

    if (!hasLoaded.current) {
      setLoading(true);
    }
    setError(null);

    try {
      const result = await processFinalization(tournamentId);
      setStatus(result);
      hasLoaded.current = true;
    } catch (err) {
      setError(err);
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, [tournamentId]);

  useEffect(() => {
    hasLoaded.current = false;
    load();
  }, [load]);

  useEffect(() => {
    if (!refreshTrigger) return;
    load();
  }, [refreshTrigger, load]);

  useEffect(() => {
    if (!tournamentId) return;

    const channel = supabase
      .channel(`finalization-status-${tournamentId}`)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "tournamentEvents",
          filter: `tournamentID=eq.${tournamentId}`,
        },
        () => {
          load();
        }
      )
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "squads",
          filter: `tournamentID=eq.${tournamentId}`,
        },
        () => {
          load();
        }
      )
      .subscribe();

    return () => {
      channel.unsubscribe();
    };
  }, [tournamentId, load]);

  return { status, loading, error, refresh: load };
}
